module.exports = __webpack_public_path__ + "img/simplepay_bankcard_logos_left.62ea72e2.jpg";